module.exports = __webpack_public_path__ + "static/media/oblong_h.9f838f1b.svg";